import React from 'react';
import PropTypes from 'prop-types';
import accounting from 'accounting';

const formatAmount = amount => {
  if (!amount && amount !== 0) {
    return `--`;
  }

  return accounting.formatNumber(amount, {
    symbol: '',
    precision: 10,
    thousand: ' ',
    format: {
      pos: '%s%v',
      neg: '-%s%v',
      zero: '%s%v'
    }
  });
};

const Quantity = ({ amount, component, className }) => {
  const Component = component || Quantity.defaultProps.component;
  const numberAmount = Number.parseFloat(amount);

  const removeTrailingZeros = (text) => {
    return text.replace(/^0+(?!\.)|(?:\.|(\..*?))0+$/gm, '$1');
  }

  return (
    <Component className={className}>{removeTrailingZeros(formatAmount(numberAmount))}</Component>
  );
};

Quantity.defaultProps = {
  component: 'span',
  amount: 0
};

Quantity.propTypes = {
  amount: PropTypes.number || PropTypes.string,
  component: PropTypes.string
};

export default Quantity;
